//文件导入页面
<template>
  <div id="import_file" v-loading="loading" element-loading-text="操作中...">
    <!-- 顶部导航条 -->
    <div class="top">
      <router-link :to="{name: 'pcibOrderAccount'}">我的账户</router-link>
      <span @click="secureEsc()">安全退出</span>
    </div>
    <!-- 详细信息部分 -->
    <el-tabs v-model="activeName" @tab-click="changeTabs">
      <el-tab-pane label="导入客户信息" name="first">
        <p class="top">客户信息导入</p>
        <el-upload
          class="upload"
          drag
          :limit="1"
          ref="customer"
          :headers="headers"
          :action="customerUrl"
          :auto-upload="autoUpload"
          :on-change="onChange"
          :on-exceed="moreFile"
          :on-success="successUpload"
          :on-error="errorUpload"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或
            <em>点击选择</em>
          </div>
          <div class="el-upload__tip" slot="tip">只能上传xls、xlsx、csv格式文件</div>
        </el-upload>
      </el-tab-pane>
      <el-tab-pane label="导入授权信息" name="second">
        <p class="top">授权信息导入</p>
        <el-upload
          class="upload"
          drag
          :limit="1"
          ref="auth"
          :headers="headers"
          :action="authUrl"
          :auto-upload="autoUpload"
          :on-change="onChange"
          :on-exceed="moreFile"
          :on-success="successUpload"
          :on-error="errorUpload"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或
            <em>点击选择</em>
          </div>
          <div class="el-upload__tip" slot="tip">只能上传xls、xlsx、csv格式文件</div>
        </el-upload>
      </el-tab-pane>
      <el-tab-pane label="客户邮件状态" name="third">
        <el-table :data="tableData" height="320" border stripe style="width: 100%">
          <el-table-column prop="real_name" label="用户名" align="center" width="160"></el-table-column>
          <el-table-column prop="username" label="客户编号" align="center" width="160"></el-table-column>
          <el-table-column prop="email" align="center" label="邮箱"></el-table-column>
          <el-table-column label="邮件状态" align="center" width="180">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.mail_status">发送成功</el-tag>
              <el-tag type="warning" v-else>发送失败</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="邮件重发" align="center" width="180">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                round
                :disabled="!scope.row.resend_mail"
                @click="resendEmail(scope.row.id)"
              >重发邮件</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          layout="total, prev, pager, next, jumper"
          :total="counts"
        ></el-pagination>
      </el-tab-pane>
    </el-tabs>
    <div class="email_status_search" v-if="activeName == 'third'">
      <el-button type="warning" plain size="mini" v-if="searchFlag" @click="quizSearch">退出搜索</el-button>
      <el-input placeholder="请输入搜索内容" v-model="emailSearch" @keyup.enter.native="searchUser">
        <el-button
          slot="append"
          icon="el-icon-search"
          title="搜索"
          :disabled="!emailSearch"
          @click="searchUser"
        ></el-button>
      </el-input>
    </div>
    <el-button
      type="primary"
      @click="upFile"
      :disabled="fileList.length === 0"
      v-if="activeName != 'third'"
    >上传</el-button>
  </div>
</template>

<script>
import { fetch, post } from "@/util/http";
export default {
  name: "pcib-order-import-file",
  beforeCreate() {
    //权限验证
    let self = this;
    let token = sessionStorage.getItem("authToken");
    let user = JSON.parse(sessionStorage.getItem("user"));
    if (!token || !user.is_superuser) {
      self.$router.push({
        name: "pcibOrderLogin"
      });
    }
  },
  watch: {},
  created() {
    let self = this;
    self.customerUrl = self.axios.defaults.baseURL + "user/import/customer/";
    self.authUrl = self.axios.defaults.baseURL + "user/import/auth/";
    //    if(self.activeName == "third") {
    //        self.emailStatus();
    //    }
  },
  data() {
    return {
      activeName: "first",
      headers: {
        Authorization: "JWT " + sessionStorage.getItem("authToken")
      },
      autoUpload: false,
      customerUrl: "",
      authUrl: "",
      fileList: [],
      loading: false, //加载框
      currentPage: 1, //当前页
      counts: 0, //数据总条数
      tableData: [], //邮件状态表格数据
      emailSearch: "", //搜索栏input值
      searchFlag: false //搜索标志位
    };
  },
  methods: {
    handleSizeChange(val) {
      this.currentPage = val;
      let content = this.searchFlag ? this.emailSearch : "";
      this.emailStatus(val - 1, content);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      let content = this.searchFlag ? this.emailSearch : "";
      this.emailStatus(val - 1, content);
    },
    quizSearch() {
      let self = this;
      self.currentPage = 1;
      self.emailSearch = "";
      self.emailStatus();
      self.searchFlag = false;
    },
    onChange(file, fileList) {
      let self = this;
      let buff_suffix = file.name.split(".");
      let suffix = buff_suffix[buff_suffix.length - 1];
      const isEXALE = suffix === "xls" || suffix === "xlsx" || suffix === "csv";
      if (!isEXALE) {
        self.$alert("上传文件只能是 xls、xlsx或csv 格式!", "文件类型错误", {
          confirmButtonText: "确定"
        });
      }
      self.fileList = fileList;
      return isEXALE;
    },
    changeTabs() {
      let self = this;
      if (self.activeName === "first") {
        self.$refs.auth.clearFiles();
      } else if (self.activeName === "second") {
        self.$refs.customer.clearFiles();
      } else {
        self.searchFlag = false;
        self.emailSearch = "";
        self.emailStatus();
      }
    },
    //点击搜索
    searchUser() {
      let self = this;
      if (self.emailSearch.trim() === "") {
        return false;
      }
      self.currentPage = 1;
      self.searchFlag = true;
      self.emailStatus(0, self.emailSearch);
    },
    //请求邮件状态
    emailStatus(num, search) {
      let self = this;
      self.loading = true;
      fetch("user/mail/status/list/", {
        limit: 10,
        offset: num ? num * 10 : 0,
        dest: search ? search : ""
      }).then(
        res => {
          self.counts = res.count;
          self.tableData = [];
          self.tableData = res.results;
          self.loading = false;
        },
        err => {
          self.loading = false;
          self.$notify({
            type: "info",
            title: "数据请求失败！",
            offset: 70
          });
        }
      );
    },
    //重发邮件
    resendEmail(id) {
      let self = this;
      fetch("user/mail/resend/" + id + "/").then(
        res => {
          let content = self.searchFlag ? self.emailSearch : null;
          //    console.log(self.currentPage);
          self.emailStatus(self.currentPage - 1, content);
          self.$notify({
            type: "success",
            title: "邮件重发成功！",
            offset: 70
          });
        },
        err => {
          self.$notify({
            type: "info",
            title: "邮件重发失败！",
            offset: 70
          });
        }
      );
    },
    upFile() {
      let self = this;
      self.loading = true;
      if (self.activeName === "first") {
        self.$refs.customer.submit();
      } else {
        self.$refs.auth.submit();
      }
    },
    moreFile() {
      this.$alert(
        "一次仅能上传一个文件，若重新选择请先删除上一个选择文件",
        "上传数量限制",
        {
          confirmButtonText: "确定"
        }
      );
    },
    successUpload(res) {
      this.loading = false;
      this.$notify({
        type: "success",
        title: "导入成功",
        offset: 70
      });
      this.$refs.customer.clearFiles();
      this.$refs.auth.clearFiles();
    },
    errorUpload(err) {
      this.loading = false;
      this.$refs.customer.clearFiles();
      this.$refs.auth.clearFiles();
      if (err.status == 401) {
        this.$notify({
          type: "error",
          title: "导入失败",
          message: "认证权限已过期，请安全退出后重新登录",
          offset: 70
        });
      } else {
        this.$notify({
          type: "error",
          title: "导入失败",
          message: "数据内容格式有误，请检查重试",
          offset: 70
        });
      }
    },
    //安全退出
    secureEsc() {
      let self = this;
      post("user/logout/").then(
        res => {
          self.$notify({
            type: "success",
            message: "安全退出成功",
            offset: 70,
            duration: 1500
          });
          sessionStorage.removeItem("authToken");
          sessionStorage.removeItem("user");
          localStorage.removeItem("authToken");
          localStorage.removeItem("user");
          self.$router.push({
            name: "pcibOrderLogin"
          });
        },
        err => {
          self.$notify({
            type: "success",
            message: "安全退出成功",
            offset: 70,
            duration: 1500
          });
          sessionStorage.removeItem("authToken");
          sessionStorage.removeItem("user");
          localStorage.removeItem("authToken");
          localStorage.removeItem("user");
          self.$router.push({
            name: "pcibOrderLogin"
          });
        }
      );
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/mirrors/auths/PcibOrderImportFile.vue